import { lazy } from 'react';

// project imports
import MainLayout from '../layout/MainLayout';
import Loadable from '../ui-component/Loadable';
import AuthGuard from '../utils/route-guard/AuthGuard';

const DemoViews = Loadable(lazy (() => import( '../DemoViews')));

// ==============================|| MAIN ROUTING ||============================== //

const DevRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/demo-views',
            element: <DemoViews />
        }
    ]
};

export default DevRoutes;
